import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AuthenticationService } from '../core/authentication/authentication.service';

@Injectable({ providedIn: 'root' })
export class CampaignMediaService {
    constructor(
        private http: HttpClient,
        private authenticationService: AuthenticationService
    ) { }

    pauseCampaignVisual(campaignId: string, mediaId: string) {
        return this.http.put(`${environment.apiUrl}/iintegration/campaign/${campaignId}/pause-visual`, {
            mediaId
        });
    }

    downloadCampaignMedia(campaignId: string) {
        return this.http.get(
            `${environment.apiUrl}/iintegration/campaign/${campaignId}/download-media/${this.authenticationService.getSessionRole()}`,
            {
                responseType: 'blob'
            }
        );
    }

    downloadCampaignMediaList(campaignId: string) {
        return this.http.get(
            `${environment.apiUrl}/iintegration/campaign/${campaignId}/download-medias`
        );
    }

    uploadDocuments(campaignId: string, previousFiles: any[], files: File[]) {
        const formData = new FormData();

        const jsonBlob = new Blob([JSON.stringify(previousFiles || [])], {
            type: 'application/json'
        });
        formData.set('previousFiles', jsonBlob);

        files.forEach(file => {
            formData.append('files', file, file.name);
        });

        return this.http.post(
            `${environment.apiUrl}/iintegration/campaign/${campaignId}/upload-documents`,
            formData,
            {
                reportProgress: true,
                responseType: 'text'
            }
        );
    }
}
